var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer",attrs:{"data-answer":_vm.answerText}},[_c('span',[_vm._v(_vm._s(_vm.answerId))]),_vm._v("\n  "+_vm._s(_vm.answerText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }